import {Avatar, Card, CardContent, TextField} from "@material-ui/core";
import AntDataGrid from "../../shared/components/AntDataGrid";
import usePublications from "../../hooks/usePublications";
import {isEmpty, keys} from "lodash";
import {SOCIAL_ICONS} from "../../shared/constants/social";
import {epochToDate} from "../../shared/functions/toDateTime";
import {useMemo, useState} from "react";
import useToggle from './../../shared/functions/useToggle';
import PublishList from './PublishForm';

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'ImageUrl',
        render: (image) => {
            return (
                <>
                    <Avatar alt={'...'} src={image}/>
                </>
            )
        }
    },
    {title: 'Title', dataIndex: 'Title', key: 'Title'},
    {title: 'Description', dataIndex: 'Description', key: 'Description', width: 300},
    {
        title: 'Social', dataIndex: 'Platforms', key: 'Platforms',
        render: (Platforms) => {
            return (
                <>
                    {
                        keys(Platforms).map(type =>
                            (
                                <img
                                    key={type}
                                    alt="---"
                                    src={SOCIAL_ICONS[type]}
                                    style={{height: 40, width: 40}}
                                    hidden={!Boolean(Platforms[type])}
                                />
                            )
                        )
                    }
                </>
            )
        }
    },
    {title: 'Publish Type', dataIndex: 'PublishType', key: 'PublishType'},
    {
        title: 'Created at', dataIndex: 'CreatedAt', key: 'CreatedAt',
        render: (date) => {
            return epochToDate(date)
        }
    },
];

const filterList = (list, keyword) => {
    return list.filter(one => {
        const _keyword = keyword.trim().toLowerCase();
        const _description = one.Description.trim().toLowerCase();
        const _title = one.Title.trim().toLowerCase();

        if (isEmpty(_keyword)) return true;

        return _title.includes(_keyword) || _description.includes(_keyword)
    })
}
export default function PublicationList() {
    const [keyword, setKeyword] = useState('');
    const {loading, list} = usePublications();
    const [selected, setSelected] = useState(null);

    const { open, handleClose, handleOpen } = useToggle();

    const data = useMemo(() => [...list.map(one => ({key: one.id, ...one}))], [list]);
    const filtered = useMemo(() => filterList(data, keyword), [data, keyword])

    const handleKeywordChange = (keyword) => setKeyword(keyword);

    const handleSelecItem =(item) =>{
        setSelected(item);
        handleOpen()
    }




    return (
        <Card style={{marginTop:50}}>
            <CardContent>

                <TextField
                    value={keyword}
                    label={"Rechercher..."}
                    variant={"outlined"}
                    onChange={event => handleKeywordChange(event.target.value)}
                    style={{
                        width: 500,
                        marginTop: 10,
                        marginLeft: 10,
                        marginBottom: 30,
                    }}
                />
                <AntDataGrid
                    columns={columns}
                    isLoading={loading}
                    data={filtered}
                    doubleClickAction ={handleSelecItem}
                />
            </CardContent>
            {open && <PublishList handleClose={handleClose} updateItem={selected} /> }
        </Card>
    )
}